import React from 'react';
import PropTypes from 'prop-types';
import { formatUtc, parseUtcDate } from '../UtcDate';

class DatePicker extends React.Component {
  static displayName = 'DatePicker';

  static defaultProps = {
    disabled: false,
    name: '',
    value: ''
  };

  static propTypes = {
    name: PropTypes.string
  };

  onChangeDateTime = (date) => {
    let value = parseUtcDate(date);
    this.props.onChange(this.props.name, value);
  };

  componentDidMount() {
    $(this.inputEl).datetimepicker({
      format: 'Y-m-d',
      mask: true,
      timepicker: false,
      value: this.props.value ? formatUtc(this.props.value, 'YYYY-MM-DD') : '',
      onChangeDateTime: this.onChangeDateTime
    });
  }

  render() {
    return (
      <input
        name={this.props.name}
        disabled={this.props.disabled}
        ref={(el) => {
          this.inputEl = el;
        }}
      />
    );
  }
}

export default DatePicker;



// WEBPACK FOOTER //
// ./src/js/Component/DatePicker.jsx